// extracted by mini-css-extract-plugin
export default {"page":"PCAy8","answers":"crEvk","answer":"C4jH4","pluginPreview":"LsQ7y","readOnlyAnswer":"CnZtP","answerImg":"SZhIP","actions":"rdZnh"};